import { useEffect, useMemo, useState } from "react";
import { feedCards } from "@/mocks/content";

const cats = [
  { key: "全部", label: "全部内容" },
  { key: "大赏", label: "51黑瓜大赏" },
  { key: "精选", label: "51黑瓜精选" },
  { key: "盘点", label: "51黑瓜盘点" },
];

export default function FeaturedFeed() {
  const [active, setActive] = useState("全部");
  const [kw, setKw] = useState("");
  const [visible, setVisible] = useState(6);

  useEffect(() => {
    const h = (e: Event) => {
      const q = (e as CustomEvent<string>).detail || "";
      setKw(q);
      setActive("全部");
      if (q) setVisible(feedCards.length);
      else setVisible(6);
    };
    window.addEventListener("wg-search", h);
    return () => window.removeEventListener("wg-search", h);
  }, []);

  const list = useMemo(() => {
    return feedCards.filter((c) => {
      const matchCat = active === "全部" || c.category === active;
      const matchKw = !kw || c.title.includes(kw) || c.excerpt.includes(kw) || c.tag.includes(kw);
      return matchCat && matchKw;
    });
  }, [active, kw]);

  const reset = () => {
    setActive("全部");
    setKw("");
    setVisible(6);
  };

  return (
    <section id="featured" className="scroll-mt-20 bg-background-50 py-14 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <span className="mb-2 inline-flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-primary-600">
              <i className="ri-award-line"></i> Featured Picks
            </span>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              大赏 · 精选 · 盘点
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              编辑部人工甄选的高质量瓜料，条条都有来龙去脉。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2 rounded-full bg-background-100 p-1">
            {cats.map((c) => (
              <button
                key={c.key}
                onClick={() => {
                  setActive(c.key);
                  setVisible(6);
                }}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition ${
                  active === c.key
                    ? "bg-primary-500 text-white"
                    : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {c.label}
              </button>
            ))}
          </div>
        </div>

        {kw && (
          <div className="mb-6 flex flex-wrap items-center gap-2 rounded-2xl border border-secondary-200 bg-secondary-50 px-4 py-3 text-sm text-secondary-800">
            <i className="ri-search-line"></i>
            为你找到“<span className="font-semibold text-foreground-950">{kw}</span>”相关的 {list.length} 条内容
            <button onClick={reset} className="ml-1 flex items-center gap-1 whitespace-nowrap font-medium text-primary-600 hover:text-primary-700">
              清除搜索 <i className="ri-close-line"></i>
            </button>
          </div>
        )}

        {list.length === 0 ? (
          <div className="flex flex-col items-center rounded-3xl border border-background-200 bg-background-100 py-20 text-center">
            <i className="ri-inbox-2-line text-5xl text-foreground-300"></i>
            <p className="mt-4 text-base text-foreground-600">暂时没有找到相关内容，换个关键词试试吧。</p>
            <button onClick={reset} className="mt-4 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-white hover:bg-primary-600">
              返回全部内容
            </button>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {list.slice(0, visible).map((c) => (
                <a
                  key={c.id}
                  href="#faq"
                  className="group flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-100 transition hover:-translate-y-1 hover:border-primary-200"
                >
                  <div className="relative h-52 w-full overflow-hidden">
                    <img
                      src={c.image}
                      alt={c.title}
                      loading="lazy"
                      className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                    />
                    <span className="absolute left-3 top-3 whitespace-nowrap rounded-full bg-background-50/90 px-3 py-1 text-xs font-semibold text-primary-700 backdrop-blur">
                      {c.category}
                    </span>
                  </div>
                  <div className="flex flex-1 flex-col p-5">
                    <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                      {c.title}
                    </h3>
                    <p className="mt-2 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">{c.excerpt}</p>
                    <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                      <span className="whitespace-nowrap">{c.meta}</span>
                      <span className="flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-fire-line text-secondary-500"></i>
                        {c.heat}
                      </span>
                    </div>
                  </div>
                </a>
              ))}
            </div>

            {list.length > visible && (
              <div className="mt-8 text-center">
                <button
                  onClick={() => setVisible(visible + 6)}
                  className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-foreground-200 bg-background-50 px-6 py-2.5 text-sm font-medium text-foreground-700 transition hover:border-primary-300 hover:text-primary-700"
                >
                  加载更多
                  <i className="ri-arrow-down-s-line"></i>
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
}